<template>
  <v-date-picker color="accent" hide-header control-variant="modal" v-bind="$attrs">
    <template
      v-slot:controls="{ viewMode, disabled, openMonths, openYears, monthYearText, yearText, prevMonth, nextMonth }"
    >
      <div class="d-flex align-center mx-auto">
        <v-btn
          density="comfortable"
          variant="text"
          icon="$prev"
          :disabled="disabled.includes('prev-month')"
          @click="prevMonth"
        ></v-btn>
        <v-btn
          class="drill-btn"
          density="default"
          variant="text"
          rounded
          :text="viewMode === 'month' ? monthYearText : yearText"
          @click="viewMode === 'month' ? openMonths() : openYears()"
        ></v-btn>
        <v-btn
          density="comfortable"
          variant="text"
          icon="$next"
          :disabled="disabled.includes('next-month')"
          @click="nextMonth"
        ></v-btn>
      </div>
    </template>
  </v-date-picker>
</template>
<script>
export default {
  name: 'MinimalDatePicker',
  inheritAttrs: false
}
</script>
<style lang="scss" scoped>
.drill-btn {
  padding-inline: 12px;
  text-transform: none;
}
</style>
